import { Dices } from "lucide-react";
import HostPanel from "./host/HostPanel";
import ProjectorView from "./projector/ProjectorView";
import BingoSettingsTab from "./settings/BingoSettingsTab";

/**
 * Bingo Show plugin definition.
 * Implements the IcPlugin contract.
 *   id, name, version, icon, description
 *   host       - React component mounted at /host/bingo
 *   projector  - React component mounted at /projector/bingo
 *   settingsTab - React component injected into /settings as a tab
 *   register() - optional bootstrap hook
 *   sync.eventTypes - list of event names this plugin publishes/consumes
 */

const BingoPlugin = {
  id: "bingo",
  name: "Bingo Show",
  version: "0.1.0",
  icon: Dices,
  description:
    "Cinematic 90-ball hotel bingo show with special number reveals, magical sparkles, and premium sound design.",
  host: HostPanel,
  projector: ProjectorView,
  settingsTab: BingoSettingsTab,
  sync: {
    eventTypes: [
      "bingo/new-game",
      "bingo/number-called",
      "bingo/number-undone",
      "bingo/number-redone",
      "bingo/mode-changed",
      "bingo/interval-changed",
      "bingo/paused",
      "bingo/resumed",
      "bingo/stage-changed",
      "bingo/winner-announced",
      "bingo/winner-dismissed",
      "bingo/manual-mark",
      "bingo/manual-unmark",
      "bingo/end-game",
      "bingo/game-summary-dismissed",
      "bingo/resume-session",
    ],
  },
  register() {
    // Bootstrap hook - nothing to do in Step 1.
  },
};

export default BingoPlugin;
